import React, { MouseEvent } from "react";

import { TThemeVariant } from "../../Utility/ThemeProvider";

export interface IAccordionContext {
  id?: string | number;
  expanded?: boolean;
  onToggle?: (event: MouseEvent<HTMLButtonElement>) => void;
  theme?: TThemeVariant;
}

export const accordionContext = React.createContext<IAccordionContext>({
  id: null,
  expanded: false,
  onToggle: null,
});
